import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { create } from 'kts-scaffold-framework/utils/form';
import { List, Button, Icon, Input, Form, Modal, Tree, message } from 'antd'; 
import { Link } from 'react-router-dom';
import DELICON from './icon/del';
import ADDICON from './icon/add';
import EDITICON from './icon/edit';
import CANCELICON from './icon/cancel'; 
const { confirm } = Modal;
const { TreeNode } = Tree;
const css = require('./index.scss');  
/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    onclose?: () => void;
    onfresh?:any;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = { 
            data: [ 
                // {
                //   value: 'Root2',
                //   defaultValue: 'Root2',
                //   key: '0-2', 
                //   isEditable: false,
                //   children: [{ 
                //     value: 'Leaf',
                //     defaultValue: 'Leaf',
                //     key: '1-1', 
                //     isEditable: false
                //   }]
                // }
              ] 
        };
    }
    initTreeData = () => {
        let data = this.modulesState.tagAllCateAndTagData && this.modulesState.tagAllCateAndTagData.map((item, index)=>({
            value: item.categoryName ,
            defaultValue: item.categoryName,
            key: item.categoryId,
            isEditable: false,
            children: item.labels && item.labels.map((child, chindex)=>({
                value: child.labelName ,
                defaultValue: child.labelName,
                key: child.labelId,
                isEditable: false,
            }))
        }));
        this.setState({data});
    }
    initData = () => {
        ModulesAction.getAllTagAndCateList().then(()=>{ 
            this.initTreeData();
        });
    }
    componentDidMount() {
        this.initData();   
    } 
    /** 关闭窗口：标签库管理 */
    closeTagManage = () => {
        if (this.props.onclose){
            this.props.onclose();   
        }
    }
    componentWillUnmount() {
        this.closeTagManage();
    }
    
    /** 新增标签分类名称 */
    toAddCategory = (e) => { 
        if (e.target.value){
            this.props.form.validateFields((err, values) => {
                if (values.categoryName && values.categoryName.trim()){  
                    ModulesAction.addTagCategory({categoryName: values.categoryName && values.categoryName.trim()}, ()=>{ 
                        this.props.form.setFieldsValue({
                            categoryName: ''
                        });
                        ModulesAction.getAllTagAndCateList().then(()=>{ 
                            this.initTreeData();
                        });
                        if (this.props.onfresh){
                            this.props.onfresh();
                        }
                    }, (msg)=>{
                        this.props.form.setFields({
                            categoryName: {
                                value: values.categoryName,
                                errors: [new Error(msg)],
                            },
                        });
                    });
                }
            });
        }
        return;
    }
    /** 新增标签 */
    addTag = (e) => {
        if (e.target.value){
            this.props.form.validateFields((err, values) => {
                if (values.tagName){ 
                    if (values.tagName.replace(/\s*/g,"") === '无标签'){
                        this.props.form.setFields({
                            tagName: {
                                value: values.tagName,
                                errors: [new Error('不能添加名称为无标签的标签')],
                            },
                        });
                        return false;
                    }
                    ModulesAction.addTag(values.tagName, ()=>{ 
                        this.props.form.setFieldsValue({
                            tagName: ''
                        });
                        if (this.props.onfresh){
                            this.props.onfresh();
                        }
                    }, (msg)=>{
                        this.props.form.setFields({
                            tagName: {
                                value: values.tagName,
                                errors: [new Error(msg)],
                            },
                        });
                    });
                }
            });
        }
        return;
    } 
    /** 编辑分类/标签组件 */
    getEditTagCategoryDom = (item) => {
        const { getFieldDecorator } = this.props.form; 
        return ( 
            <Form.Item label="" extra="">
            {getFieldDecorator(`form_${item.key}`, {
                initialValue:item.value,
                rules: [{ required: true, message: ` 请输入${item.children ? '分类':'标签'}名称！`, whitespace: true}],
            })(
                <Input 
                    onPressEnter={(e)=>{
                        e.preventDefault(); 
                        this.addTagName(e, item.key, !!item.children);
                        }
                    } 
                    placeholder={item.children ? '分类' : '标签'} 
                    onChange={(e) => this.onChange(e, item.key)} 
                    style={{width: '100%'}} 
                    maxLength={15} 
                    minLength={1} 
                />
            )}
        </Form.Item>
            );
    }
    onSelect = (keys, event) => {
        console.log('Trigger Select', keys, event);
    }
    
    onExpand = expandedKeys => { 
        this.modulesState.expandedKeys = expandedKeys;
        this.setModulesState();
    }
    onChange = ({ target: { value } }, key) => {
        this.changeNode(key, value, this.state.data);
        this.setState({
            data: [...this.state.data]
        });
    }
    onTextClose = (key, defaultv) => {
        this.closeNode(key, defaultv, this.state.data);
        this.setState({
            data: [...this.state.data]
        });
    }
    /** 回车保存标签 */
    addTagName = (e, key, isCategory) => {
        let _name = e.target.value && e.target.value.trim(); 
        if (_name){ 
            /** 本地查询是否存在重名 */ 
            if (this.queryName(_name, isCategory)){ 
                this.props.form.setFields({
                    [`form_${key}`]: {
                        value:  _name,
                        errors: [new Error(`${isCategory ? ' 分类' : ' 标签'}名称已存在`)],
                    },
                });  
                return false;
            } else {
                this.onSave(key, isCategory); 
            }
        }
    }
    /** 查询是否存在此名称 */
    queryName = (name, isCategory) => {
        const data = this.state.data;
        for (let i = 0; i<data.length; i++){ 
            if (isCategory) { 
                if (data[i].defaultValue === name){
                    return true;
                }
            } else { 
                if(data[i].children){
                    for (let j = 0; j < data[i].children.length; j++){
                        if (data[i].children[j].defaultValue === name){ 
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    /** 保存 */
    onSave = (key, isCategory) => {  
        this.saveNode(key, this.state.data, isCategory);
        // this.setState({
        //     data: [...this.state.data]
        // });
    }
    onEdit = (key) => { 
        this.editNode(key, this.state.data); 
        this.setState({ 
            data: [...this.state.data]
        });
    }
    onAdd = (key, isCategory) => {
        /** 如果页面中已经存在以前的新增输入框，删除 */
        for (let i = 0; i < this.state.data.length ; i++){
            let _key = this.state.data[i].key;
            if (typeof(_key) === 'string' && _key.indexOf('add_')>=0){
                // return;
                // 删除页面中已经存在的新增输入框
                this.onDelete(_key, isCategory);
                break;
            }
        }
        this.addSameLevelNode(key, this.state.data, isCategory);
        this.setState({
            data: [...this.state.data]
        }); 
    }

    addSameLevelNode = (key, data, isCategory) => data.map((item, index) => {
            // console.log('key', key, item.key);
        if (item.key === key) {
            let _key = (Math.random() * 10000); 
            let _item = {
                value: '',
                defaultValue: '',
                key: isCategory ? 'add_' + _key : 'add_' + key,  // 新增同级分类、添加子标签
                isEditable: true,
                children: []
            };
            if (!isCategory){
                delete _item.children;
            } 
            data.splice(index + 1, 0, _item);
            return;
        } else {
            if (item.children) {
              this.addSameLevelNode(key, item.children, !!item.children);
            }
        }
    })
    onDelete = (key, isCategory) => {
        this.deleteNode(key, this.state.data, isCategory);
        this.setState({
            data: [...this.state.data]
        }); 
    }
    deleteNode = (key, data, isCategory) => data.map((item, index) => {
        if (item.key === key) { 
            // 新增的输入框，只需本地删除，不需要走api
            if (typeof(key) === 'string' && key.indexOf('add_')>=0){ 
                data.splice(index, 1);
                return;
            }
            if (isCategory) {
                // 删除分类
                ModulesAction.delTagCategory(key, () => {
                    this.initData();
                });
            }else{
                // 删除标签，先验证该标签是否绑定了公司，如果绑定了给予提示
                ModulesAction.tagLinkCompanys(key, (_companys) => {  
                    let _this = this;
                    if (_companys && _companys.length > 0){ 
                        // 标签下关联有公司，提示是否确定删除
                        confirm({
                            title: '提示',
                            content: '该标签已关联了公司，若删除，则将同时删除该标签与公司之前的关联，确认删除？',
                            onOk() {
                                ModulesAction.delTag(key, () => {
                                    _this.initData();
                                }); 
                            },
                            onCancel() {},
                        });
                    } else { 
                        ModulesAction.delTag(key, () => {
                            _this.initData();
                        });
                    } 
                });   
            }
        } else {
          if (item.children) {
            this.deleteNode(key, item.children, !!item.children.children);
          }
        }
    })
    closeNode = (key, defaultValue, data) => data.map((item, index) => {
        if (item.key === key) {
          item.value = defaultValue;
          item.isEditable = false;
          // 判断是否是本地新增的，还没入库，如是，则关闭等于删除
          if (item.value === '' && item.defaultValue === ''){
            data.splice(index, 1);
          }
        }
        if (item.children) {
          this.closeNode(key, defaultValue, item.children);
        }
    })
    editNode = (key, data) => data.map((item) => { 
        if (item.key === key) {
          item.isEditable = true;
        } else {
          item.isEditable = false;
        }
        //Tip: Must have, when a node is editable, and you click a button to make other node editable, the node which you don't save yet will be not editable, and its value should be defaultValue 
        item.value = item.defaultValue; // 当某节点处于编辑状态，并改变数据，点击编辑其他节点时，此节点变成不可编辑状态，value 需要回退到 defaultvalue
        if (item.children) {
          this.editNode(key, item.children);
        }
    })
    changeNode = (key, value, data) => data.map((item) => {
        if (item.key === key) {
          item.value = value;
        }
        if (item.children) {
          this.changeNode(key, value, item.children);
        }
    })
    saveNode = (key, data, isCategory) => data.map((item) => {  
        if (item.key === key) {  
            item.defaultValue = item.value;
            item.isEditable = false;
            /** 标签分类名称 */ 
            if (isCategory) {
                /** 有add_,是新增 */  
                if (typeof(key) === 'string' && key.indexOf('add_')>=0){
                    ModulesAction.addTagCategory({ 
                        categoryName: item.value
                    }, ()=>{
                        /** 成功 */
                        if (this.props.onfresh){
                            this.props.onfresh();
                        }
                        this.initData();
                    },(errmsg)=>{
                        /** 失败 */
                        console.log('新增分类失败:', errmsg); 
                        this.props.form.setFields({
                            [`form_${key}`]: {
                                value:  item.value,
                                errors: [new Error(errmsg)],
                            },
                        });
                        message.error(errmsg);
                        this.initData();
                        return false; 
                    });
                } else {
                    /** 无add_是编辑分类名称  */
                    ModulesAction.editTagCategory({
                        categoryId: key,
                        categoryName: item.value
                    }, ()=>{
                        /** 成功 */
                        if (this.props.onfresh){
                            this.props.onfresh();
                        }
                        // this.setState({
                        //     data: [...this.state.data]
                        // });
                        this.initData();
                    },(errmsg)=>{
                        /** 失败 */
                        console.log('编辑分类失败:', errmsg);
                        this.props.form.setFields({
                            [`form_${key}`]: {
                                value:  item.value,
                                errors: [new Error(errmsg)],
                            },
                        });
                        message.error(errmsg);
                        this.initData();
                        return false; 
                    });
                } 
            } else { 
                /** 标签名称 */
                if (typeof(key) === 'string' && key.indexOf('add_')>=0){
                    /** add_,新增标签 */
                    ModulesAction.addTag({ 
                        categoryId: key.split('_')[1],
                        labelName: item.value
                    }, ()=>{
                        /** 成功 */
                        if (this.props.onfresh){
                            this.props.onfresh();
                        }
                        /** 第一次新增的标签，默认展开该分类 */ 
                        if (this.modulesState.expandedKeys && this.modulesState.expandedKeys.indexOf(key.split('_')[1]) <= 0){
                            this.modulesState.expandedKeys.push(key.split('_')[1]);
                        }
                        this.setModulesState();
                        this.initData();
                    },(errmsg)=>{
                        /** 失败 */
                        console.log('新增标签失败:', errmsg);
                        message.error(errmsg);
                        this.props.form.setFields({
                            [`form_${key}`]: {
                                value:  item.value,
                                errors: [new Error(errmsg)],
                            },
                        });
                        this.initData();
                        return false; 
                    });
                } else {
                    /** 修改标签名称 */
                    ModulesAction.editTag({
                        labelId: key,
                        labelName: item.value
                    }, ()=>{
                        /** 成功 */
                        if (this.props.onfresh){
                            this.props.onfresh();
                        }
                        this.initData();
                    },(errmsg)=>{
                        /** 失败 */
                        console.log('修改标签失败:', errmsg); 
                        this.props.form.setFields({
                            [`form_${key}`]: {
                                value:  item.value,
                                errors: [new Error(errmsg)],
                            },
                        });  
                        message.error(errmsg);
                        this.initData();
                        return false;  
                    });
                }
          }
        }
        if (item.children) { 
          this.saveNode(key, item.children, !!item.children.children);
        }
    })

    renderTreeNodes = (data) => data.map((item, index) => {   
        if (item.isEditable) {  // 编辑状态下 
            let _marginLeft = '0px';
            if (typeof(item.key) === 'string' && item.key.indexOf("add_")>=0){ 
                _marginLeft = item.children ? '0px' : '18px';
            } else {
                _marginLeft = '0px';
            } 
            item.title = (
              <div className={css.opertitle}>
                <div style={{width: item.children ? '200px' : '182px', float: 'left', height: '30px',marginLeft: _marginLeft}}> 
                    {this.getEditTagCategoryDom(item)}
                </div> 
                <div className={css.operbtns} style={{ height: '20px', lineHeight: '30px', textAlign: 'right'}}>
                    {/* <Icon type='close' style={{marginLeft: 40}} onClick={() => this.onTextClose(item.key, item.defaultValue)}/> */}
                    {/* <Icon type='check' style={{marginLeft: 10}} onClick={() => this.onSave(item.key, !!item.children)}/>  */}
                    <i dangerouslySetInnerHTML={{ __html: CANCELICON }} style={{marginLeft: '10px'}}  onClick={() => this.onTextClose(item.key, item.defaultValue)}  />
                </div>
              </div>
            );
        } else {
            item.title = (
              <div className={css.opertitle}> 
                <div style={{width: item.children ? '304px' : '313px', float: 'left', height: '20px', lineHeight: '20px'}}>
                  {item.value}
                </div>
                <div className={css.operbtns} style={{ textAlign: 'right',}}>
                    {/* <Tooltip title={'修改名称'}>
                    <Icon type='edit' style={{marginLeft: '40px'}} onClick={() => this.onEdit(item.key)} />
                    </Tooltip> */} 
                    {item.children &&  <i dangerouslySetInnerHTML={{ __html: ADDICON }}  style={{marginLeft: '40px'}} onClick={() => this.onAdd(item.key, false)} />}
                    <i dangerouslySetInnerHTML={{ __html: EDITICON }} style={{marginLeft: item.children ? '10px' : '40px'}} onClick={() => this.onEdit(item.key)} />
                    {/* {item.children && 
                        <Tooltip title={'添加分类'}>
                            <Icon type='plus' style={{marginLeft:'10px'}} onClick={() => this.onAdd(item.key, true)} />
                        </Tooltip>
                    } */}
                    {/* // <Tooltip title={'添加标签'}>
                        // <Icon type='plus-circle' style={{marginLeft: '10px'}} onClick={() => this.onAdd(item.key, false)} />
                    // </Tooltip> */}
                    
                    {/* // 根节点没有删除按钮 */}
                    {item.children && item.children.length > 0 ? null : (
                        // <Icon type='minus' style={{marginLeft: '10px'}} onClick={() => this.onDelete(item.key, !!item.children)} />
                        <i dangerouslySetInnerHTML={{ __html: DELICON }} style={{marginLeft: '10px'}}  onClick={() => this.onDelete(item.key, !!item.children)}  />
                    )}  
                </div>
              </div>
            );
        }
       
        if (item.children) {
            return (
              <TreeNode title={item.title} key={item.key} dataRef={item}>
                {this.renderTreeNodes(item.children)}
              </TreeNode>
            );
        } 
        return <TreeNode key={item.key} {...item}/>;  
    })
    render() { 
        const { getFieldDecorator } = this.props.form;    
        return (
            <div className={`${css.tagComponentContain}`}> 
                <div className={`${css.content} ${css.tagcategoryman}`}>   
                    <Tree
                        // showLine={true}
                        // defaultExpandAll={true}
                        // autoExpandParent={true}
                        expandedKeys={this.modulesState.expandedKeys || []}
                        onExpand={this.onExpand}
                        // defaultSelectedKeys={['0-0-0']} 
                    >
                        {this.renderTreeNodes(this.state.data)}  
                    </Tree>  
                    <div style={{marginTop: 20}}>
                        <Form.Item label="" extra="回车以新增标签分类">
                        {getFieldDecorator('categoryName', {
                                initialValue:'',
                                rules: [{ required: true, message: ' 请输入标签分类名称！', whitespace: true}],
                            })(<Input onPressEnter={this.toAddCategory} maxLength={15}/>)}
                        </Form.Item> 
                    </div>
                </div>  
                {/* <div className={css.footer}> 
                    <Button className='kts-but-default' onClick={this.closeTagManage}>关闭</Button>
                </div>   */}
            </div> 
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/TagTreeComponent/UI.Components.tsx